import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { useLogger } from "logging";

const useTrackPageView = (props) => {
  const { portal } = props;

  const { csrUser } = useSelector((state) => state.csrUser);
  const { user } = useSelector((state) => state.user);
  const location = useLocation();
  const logger = useLogger();

  useEffect(() => {
    logger.trackEvent("Pageview", {
      csrRoleName: csrUser?.role?.roleName ?? "",
      csrUserName: csrUser?.userName ?? "",
      path: location?.pathname ?? "",
      portal: portal ?? "",
      roleName: user?.role?.roleName ?? "",
      userName: user?.userName ?? "",
    });
  }, [location?.pathname]);
};

export default useTrackPageView;
